import React, { useEffect, useMemo } from "react";
import { toast } from "react-toastify";
import { getDomainConfig, useAppDispatch, useAppSelector } from "@hypexone/uicore";
import Topbanner from "../../../assets/images/banners/APK-DOWNLOADER-POPUP-top.jpg";
import Bottombanner from "../../../assets/images/banners/APK-DOWNLOADER-POPUP-buttom.jpg";
import { isApkCopyLinkDomain } from "../../../constants/apkCopyLink";
import { BRAND_DOMAIN, domain } from "../../../constants/Branding";
import { getEnvVariable } from "../../../constants/brandConfig";
import "./OldApkForceUpdateModal.scss";

/**
 * Full-screen APK force-update screen for listed domains.
 * Replaces all app routes — URL changes do not show other pages.
 */
const OldApkForceUpdateModal: React.FC = () => {
  const dispatch = useAppDispatch();
  const domainConfig = useAppSelector((state) => state.common.domainConfig);

  const shouldForce = useMemo(() => isApkCopyLinkDomain(), []);
  const apkUrl = getEnvVariable(domain, "apk_url") || domainConfig?.apkUrl;
  const registrationWhatsapp = domainConfig?.suppportContacts?.find(
    (ct: { contactType?: string; details?: string }) =>
      ct.contactType === "REGISTRATION_WHATSAPP_LINK"
  )?.details;

  useEffect(() => {
    if (!shouldForce) return;
    dispatch(getDomainConfig(BRAND_DOMAIN));
  }, [dispatch, shouldForce]);

  const resolveApkHref = () => {
    if (!apkUrl) return null;
    return apkUrl.startsWith("http") ? apkUrl : `https://${apkUrl}`;
  };

  const copyApkLink = async () => {
    const url = resolveApkHref();
    if (!url) return;
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      window.prompt("Copy this APK link:", url);
    }
    toast.success("Link copied. Open browser and paste to download the new APK.");
  };

  const openRegistrationWhatsapp = () => {
    if (!registrationWhatsapp) return;
    const href = registrationWhatsapp.startsWith("http")
      ? registrationWhatsapp
      : `https://api.whatsapp.com/send?phone=${registrationWhatsapp}`;
    window.open(href, "_blank", "noopener,noreferrer");
  };

  if (!shouldForce) return null;

  return (
    <div className="old-apk-force-screen">
      {apkUrl ? (
        <div className="popup-banner-wrapper popup-banner-wrapper--old-apk">
          <a
            href={resolveApkHref() || "#"}
            onClick={(e) => {
              e.preventDefault();
              copyApkLink();
            }}
          >
            <img src={Topbanner} alt="Download APK" />
          </a>
          <div
            className="old-apk-link-bar"
            role="button"
            tabIndex={0}
            onClick={copyApkLink}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                copyApkLink();
              }
            }}
            style={{ cursor: "pointer" }}
          >
            <p className="old-apk-link-bar__label">Official APK link</p>
            <div className="old-apk-link-bar__row">
              <p
                className="old-apk-link-bar__url"
                title={resolveApkHref() || apkUrl}
              >
                {apkUrl}
              </p>
              <button
                type="button"
                className="old-apk-link-bar__copy"
                onClick={(e) => {
                  e.stopPropagation();
                  copyApkLink();
                }}
              >
                Copy
              </button>
              {registrationWhatsapp ? (
                <button
                  type="button"
                  className="old-apk-link-bar__whatsapp"
                  aria-label="Open WhatsApp"
                  onClick={(e) => {
                    e.stopPropagation();
                    openRegistrationWhatsapp();
                  }}
                >
                  <svg
                    viewBox="0 0 32 32"
                    width="20"
                    height="20"
                    aria-hidden="true"
                  >
                    <path
                      fill="#fff"
                      d="M16 0C7.2 0 0 7.2 0 16c0 2.8.7 5.5 2.1 7.9L.1 31.9l8.2-2.1C10.6 31.2 13.2 32 16 32c8.8 0 16-7.2 16-16S24.8 0 16 0zm0 29.2c-2.5 0-4.9-.7-7-1.9l-.5-.3-4.8 1.2 1.3-4.6-.3-.5c-1.3-2.1-2-4.5-2-7C2.7 8.7 8.7 2.7 16 2.7S29.3 8.7 29.3 16 23.3 29.2 16 29.2zm8.3-10.9c-.4-.2-2.6-1.3-3-1.4-.4-.2-.7-.2-1 .2-.3.4-1.1 1.4-1.4 1.7-.2.3-.5.3-1 .1-.4-.2-1.8-.7-3.5-2.2-1.3-1.1-2.1-2.6-2.4-3-.2-.4 0-.6.2-.8.2-.2.4-.5.6-.7.2-.2.3-.4.4-.7.1-.3 0-.5-.1-.7-.1-.2-1-2.4-1.4-3.3-.4-.9-.7-.7-1-.8h-.9c-.3 0-.7.1-1.1.5-.4.4-1.5 1.4-1.5 3.5s1.5 4 1.7 4.3c.2.3 3 4.5 7.2 6.3 2.7 1.1 3.7 1.2 5 .9.8-.1 2.6-1.1 3-2.1.4-1 .4-1.9.3-2.1-.2-.1-.5-.3-.9-.5z"
                    />
                  </svg>
                </button>
              ) : null}
            </div>
            <p className="old-apk-link-bar__hint">
              Browser mein paste karke new APK download kardo
            </p>
          </div>
          <a
            href={
              registrationWhatsapp
                ? registrationWhatsapp.startsWith("http")
                  ? registrationWhatsapp
                  : `https://api.whatsapp.com/send?phone=${registrationWhatsapp}`
                : "#"
            }
            onClick={(e) => {
              e.preventDefault();
              openRegistrationWhatsapp();
            }}
            style={{ cursor: registrationWhatsapp ? "pointer" : "default" }}
          >
            <img src={Bottombanner} alt="WhatsApp support" />
          </a>
        </div>
      ) : null}
    </div>
  );
};

export default OldApkForceUpdateModal;
